module.exports = __webpack_public_path__ + "static/media/Arrow-down.c03e4f0e.svg";